module.exports = __webpack_public_path__ + "static/award-5e9b288506fff6c771d996e8a342dd13.png";